import { useReducerData, useReducerLoading } from 'store/hooks';
import { REDUCER_NAMES, REDUCER_ATTRIBUTES } from 'helper/store';

export const useSelectPackages = () =>
  useReducerData(
    REDUCER_NAMES.PACKAGES,
    REDUCER_ATTRIBUTES.PACKAGES.PACKAGES,
    []
  );

export const useSelectPackagesLoading = () =>
  useReducerLoading(
    REDUCER_NAMES.PACKAGES,
    REDUCER_ATTRIBUTES.PACKAGES.PACKAGES
  );
